// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__s4N3W","rotate":"Loader_rotate__IdL85"};